import { render, staticRenderFns } from "./GroupNames.vue?vue&type=template&id=ca515c5c&"
import script from "./GroupNames.vue?vue&type=script&lang=js&"
export * from "./GroupNames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports